module.exports = __webpack_public_path__ + "img/chevron-double-left.af981a3b.svg";